// constants.ts
export var DEFAULT_HEADERS = {};